import { Injectable } from '@angular/core';
import { ConfigClient, FeatureManagement } from './api.service';
import { BehaviorSubject, Observable, combineLatest, filter, map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureManagementService {
  private featureSubject = new BehaviorSubject<FeatureManagement | undefined>(undefined);
  private featuresLoadedSubject = new BehaviorSubject<boolean>(false);
  featuresLoaded$ = this.featuresLoadedSubject.asObservable();

  isInformationObscurityActiveSubject = new BehaviorSubject<boolean>(false);
  isInformationObscurityActive$ = this.isInformationObscurityActiveSubject.asObservable();

  initialFeatureState!: FeatureManagement;

  constructor(configClient: ConfigClient) {
    configClient.featureConfig().subscribe((featureState) => {
      this.initialFeatureState = JSON.parse(JSON.stringify(featureState));
      this.featureSubject.next(featureState);
      this.featuresLoadedSubject.next(true);
    });
  }

  get features(): Observable<FeatureManagement> {
    return combineLatest([this.featureSubject, this.isInformationObscurityActive$]).pipe(
      filter(([features, _]) => !!features),
      map(([features, isInformationObscurityActive]) => {
        if (features) {
          features.informationObscurity = this.initialFeatureState.informationObscurity && isInformationObscurityActive;
        }
        return features;
      }),
    ) as Observable<FeatureManagement>;
  }

  isFeatureEnabled(featureName: keyof FeatureManagement): Observable<boolean> {
    return this.featureSubject.pipe(
      filter((config) => !!config),
      map((config) => config![featureName] as boolean),
      shareReplay(1),
    );
  }

  toggleInformationObscurityActiveState() {
    this.isInformationObscurityActiveSubject.next(!this.isInformationObscurityActiveSubject.getValue());
  }
}
